import { createSlice } from '@reduxjs/toolkit'


const slice = createSlice({
	name: 'crashLogging',
	initialState:{
		show:false,
		debugData:null
	},
	reducers: {
		notifyUserOfCrash:(state,action)=>{
			state.show = true
			state.debugData = action.payload
		},
	},

})

export const {notifyUserOfCrash} = slice.actions

export default slice.reducer